var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"th-sortable",on:{"click":_vm.onClick}},[_vm._t("default"),_c('font-awesome-icon',{staticClass:"sort-icon",attrs:{"icon":_vm.iconName}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }